import { FeatureFlagsState } from '@/@types'

const state: FeatureFlagsState = {
  flags: {
    showOldSearch: false,
    keepOldSearch: false,
    labExperienceCollection: false,
    LabExperienceEnhance: false,
    AccredibleDisabled: false,
    contactSupportToUpgrade: true,
    maintenanceScheduled: '',
    maintenanceOnGoing: false,
  },
}

export default state
